import { values } from './enums'

const _enum = {
  Active: 0,
  Resolved: 1
}

export const reportCellCommentStatus = {
  enumName: 'ReportCellCommentStatus',
  enum: _enum,
  values: values(_enum)
}



// WEBPACK FOOTER //
// ./src/enums/reportCellCommentStatus.js